import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PesoUnidadFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PESO UNIDAD' htmlFor='number-pesoUnidad' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='pesoUnidad'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='number-pesoUnidad'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PesoUnidadFormGroup)
